// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__VMLgn","title":"ClientCherryInfo_title__1Bn_d","itemText":"ClientCherryInfo_itemText__2k1wv"};